export default __webpack_public_path__ + "static/monotype-helvetica-display-349ae38eab425cd4e19bec74c457d7a1.woff2";